import { EEARType } from '../../model/enum/reporting/eear-type.enum';
import { LazyLoadedStatesManager } from '../class/lazy-loaded-states-manager.class';
import { LazyLoadedStates } from '../interfaces/lazy-loaded-states.interface';

export const ReportingLazyLoadedStates = new LazyLoadedStatesManager<{
    base: LazyLoadedStates,
    componentsReport: LazyLoadedStates,
    observationSummaryReport: LazyLoadedStates,
    growthAndStrengthsReport: LazyLoadedStates,
    educatorEffectivenessAnnualReport: LazyLoadedStates,
    eearIndividual: LazyLoadedStates,
    eearBuilding: LazyLoadedStates
}>({
    base: {
        name: 'authenticated.reporting',
        url: '/reporting',
    },
    componentsReport: {
        name: 'authenticated.reporting.components-report',
        url: '/components-report?schoolYear&bid&orderBy&ascending',
        params: {
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    observationSummaryReport: {
        name: 'authenticated.reporting.observation-summary-report',
        url: '/observation-summary-report?schoolYear&bid&orderBy&ascending',
        params: {
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    growthAndStrengthsReport: {
        name: 'authenticated.reporting.growth-and-strengths-report',
        url: '/growth-and-strengths-report?schoolYear&bid&orderBy&ascending',
        params: {
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    educatorEffectivenessAnnualReport: {
        name: 'authenticated.reporting.eear',
        url: '/eear?ratingFormType&schoolYear&bid&orderBy&ascending',
        abstract: true,
        params: {
            ratingFormType: {
                raw: true,
                type: 'string'
            },
            schoolYear: {
                raw: true,
                type: 'string'
            },
            bid: {
                raw: true,
                type: 'string'
            },
            orderBy: {
                raw: true,
                type: 'string',
                value: ''
            },
            ascending: {
                raw: true,
                type: 'string',
                value: 'true'
            }
        }
    },
    eearBuilding: {
        name: 'authenticated.reporting.eear.building',
        url: '/building',
        params: {
            eearType: {
                raw: true,
                type: 'string',
                value: `${EEARType.BUILDINGS}`
            }
        }
    },
    eearIndividual: {
        name: 'authenticated.reporting.eear.individual',
        url: '/individual',
        params: {
            eearType: {
                raw: true,
                type: 'string',
                value: `${EEARType.INDIVIDUALS}`
            }
        }
    }
},
    () => import('src/app/reporting/reporting.module').then((result: { ReportingModule: any }) => result.ReportingModule)
);
